import { Button } from 'react-bootstrap';

export default function LaudoActionButtons({ actions = [] }) {
  if (!actions.length) return null;

  return (
    <div className="d-flex justify-content-center flex-wrap">
      {actions.map((action) => {
        // Aceita ícone customizado ou usa o do WhatsApp como padrão para 'enviar'
        const iconClass = action.icon || (action.key === 'enviar' ? 'bi bi-whatsapp' : null);

        return (
          <Button
            key={action.key || action.label}
            variant={action.variant || 'secondary'}
            onClick={action.onClick}
            disabled={Boolean(action.disabled)}
            title={action.title || action.label}
            className={`mx-1 my-1 ${action.className || ''}`}
          >
            {iconClass && <i className={`${iconClass} mr-1`} />}
            {action.label}
          </Button>
        );
      })}
    </div>
  );
}
